var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_22989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 122.009L36.5385 40.3721H82.4038L114 122.009H8Z",
    fill: "url(#paint0_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M33.3366 28.2225C33.2524 16.5003 45.0047 6.94726 59.5371 6.86383C74.0696 6.7804 85.9482 16.2082 85.9904 27.8888L33.3366 28.2225Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2888 27.8894C44.2467 19.8381 51.5761 13.247 60.7167 13.2053C69.8574 13.1636 77.2711 19.6296 77.3132 27.7225L44.2888 27.8894Z",
    fill: "url(#paint1_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3365 28.2224L19.1411 33.6455L99.9751 33.1866L86.2851 27.8887L33.3365 28.2224Z",
    fill: "url(#paint2_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.184 33.1716L16.7967 33.7009C15.8061 33.707 15.0079 34.515 15.0141 35.5057C15.0202 36.4964 15.8283 37.2946 16.819 37.2885L103.206 36.7592C104.197 36.7531 104.995 35.9451 104.989 34.9544C104.983 33.9637 104.175 33.1655 103.184 33.1716Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2245 44.4499C42.2245 44.4499 24.7014 40.7789 20.2364 37.233L46.4368 37.0662L99.4697 36.7324C99.4697 36.7324 88.1386 44.3665 77.5657 44.2413C77.5657 44.2413 77.4393 47.8289 73.3113 47.8289C69.1832 47.8706 46.7738 47.9958 46.7738 47.9958C46.7738 47.9958 41.6769 47.1615 41.6769 44.3248",
    fill: "url(#paint3_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.8115 13.1631C61.8115 13.1631 70.9943 18.7531 67.4139 27.722L75.7963 27.6803C75.7963 27.6803 75.4172 15.6661 61.8115 13.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3636 24.4686C47.3214 24.3017 47.2793 24.1348 47.2793 23.968C47.1108 20.9644 50.944 16.2088 54.0611 15.9585C55.2827 15.875 56.757 17.0014 56.0409 18.2946C55.1142 20.0049 53.9347 21.5484 52.7132 23.0502C51.8286 24.1765 50.6913 26.1372 48.9642 25.7618C48.206 25.6366 47.6163 25.1777 47.3636 24.4686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.5791 24.1344C59.5791 25.3024 58.6524 26.2619 57.4308 26.2619C56.2513 26.2619 55.2825 25.3441 55.2825 24.1344C55.2825 22.9663 56.2092 22.0068 57.4308 22.0068C58.6102 22.0486 59.5791 22.9663 59.5791 24.1344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5041 34.6629L17.0244 34.7147C16.6558 34.7169 16.3588 35.0176 16.3611 35.3862C16.3634 35.7548 16.6641 36.0518 17.0327 36.0496L25.5125 35.9978C25.8811 35.9956 26.1781 35.6949 26.1758 35.3263C26.1735 34.9577 25.8728 34.6607 25.5041 34.6629Z",
    fill: "url(#paint4_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3318 34.663L31.8521 34.7147C31.4834 34.7169 31.1864 35.0176 31.1887 35.3862C31.191 35.7548 31.4917 36.0518 31.8603 36.0496L40.3401 35.9979C40.7087 35.9957 41.0057 35.695 41.0034 35.3264C41.0011 34.9578 40.7004 34.6608 40.3318 34.663Z",
    fill: "url(#paint5_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2009 34.663L46.7212 34.7147C46.3526 34.7169 46.0556 35.0176 46.0579 35.3862C46.0602 35.7548 46.3609 36.0518 46.7295 36.0496L55.2092 35.9979C55.5778 35.9957 55.8748 35.695 55.8725 35.3264C55.8702 34.9578 55.5696 34.6608 55.2009 34.663Z",
    fill: "url(#paint6_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.029 34.705L61.5492 34.7567C61.1806 34.7589 60.8836 35.0596 60.8859 35.4282C60.8882 35.7968 61.1889 36.0938 61.5575 36.0916L70.0373 36.0399C70.4059 36.0376 70.7029 35.737 70.7006 35.3684C70.6983 34.9997 70.3976 34.7027 70.029 34.705Z",
    fill: "url(#paint7_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8987 34.58L76.4189 34.6317C76.0503 34.6339 75.7533 34.9346 75.7556 35.3032C75.7579 35.6718 76.0586 35.9688 76.4272 35.9666L84.907 35.9149C85.2756 35.9126 85.5726 35.612 85.5703 35.2434C85.568 34.8747 85.2673 34.5777 84.8987 34.58Z",
    fill: "url(#paint8_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7263 34.4549L91.2466 34.5067C90.878 34.5089 90.581 34.8096 90.5833 35.1782C90.5856 35.5468 90.8863 35.8438 91.2549 35.8416L99.7346 35.7899C100.103 35.7876 100.4 35.4869 100.398 35.1183C100.396 34.7497 100.095 34.4527 99.7263 34.4549Z",
    fill: "url(#paint9_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 120.414,
    rx: 30,
    ry: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 57,
    width: 54,
    height: 54,
    rx: 16,
    fill: "url(#paint10_linear_1194_22989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 85.5C73.1022 85.5 72.7206 85.658 72.4393 85.9393C72.158 86.2206 72 86.6022 72 87V91.5C72 92.6935 71.5259 93.8381 70.682 94.682C69.8381 95.5259 68.6935 96 67.5 96H52.5C51.3065 96 50.1619 95.5259 49.318 94.682C48.4741 93.8381 48 92.6935 48 91.5V76.5C48 75.3065 48.4741 74.1619 49.318 73.318C50.1619 72.4741 51.3065 72 52.5 72H60C60.3978 72 60.7794 71.842 61.0607 71.5607C61.342 71.2794 61.5 70.8978 61.5 70.5C61.5 70.1022 61.342 69.7206 61.0607 69.4393C60.7794 69.158 60.3978 69 60 69H52.5C50.5116 69.0024 48.6053 69.7933 47.1993 71.1993C45.7933 72.6053 45.0024 74.5116 45 76.5V91.5C45.0024 93.4884 45.7933 95.3947 47.1993 96.8007C48.6053 98.2067 50.5116 98.9976 52.5 99H67.5C69.4884 98.9976 71.3947 98.2067 72.8007 96.8007C74.2067 95.3947 74.9976 93.4884 75 91.5V87C75 86.6022 74.842 86.2206 74.5607 85.9393C74.2794 85.658 73.8978 85.5 73.5 85.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.515 85.7131C52.5604 86.0294 52.7057 86.323 52.9297 86.551C53.1536 86.779 53.4445 86.9295 53.76 86.9806C53.8393 86.9937 53.9196 87.0002 54 87.0001C54.2787 87.0002 54.552 86.9227 54.7891 86.7761C55.0263 86.6296 55.2179 86.4199 55.3425 86.1706C57.204 82.4461 62.157 82.2226 64.5 82.3621V85.5001C64.5001 85.7967 64.5881 86.0866 64.7529 86.3333C64.9177 86.5799 65.152 86.7721 65.426 86.8856C65.7001 86.9991 66.0016 87.0288 66.2925 86.971C66.5835 86.9131 66.8507 86.7703 67.0605 86.5606L74.5605 79.0606C74.7097 78.9114 74.8258 78.7325 74.9012 78.5355C74.9765 78.3384 75.0095 78.1277 74.9979 77.9171C74.9863 77.7064 74.9303 77.5006 74.8338 77.3131C74.7372 77.1255 74.6022 76.9604 74.4375 76.8286L66.9375 70.8286C66.7169 70.6519 66.4508 70.5412 66.17 70.5092C65.8891 70.4771 65.605 70.5251 65.3502 70.6476C65.0955 70.77 64.8805 70.9619 64.7301 71.2012C64.5796 71.4405 64.4999 71.7174 64.5 72.0001V74.8771C60.3 74.6806 57.09 75.6796 54.9885 77.8456C54.0452 78.9087 53.3373 80.1592 52.911 81.515C52.4847 82.8708 52.3498 84.3014 52.515 85.7131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1194_22989",
    x1: 61,
    y1: 40.3721,
    x2: 61,
    y2: 122.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1194_22989",
    x1: 60.8009,
    y1: 13.2051,
    x2: 60.8009,
    y2: 27.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1194_22989",
    x1: 59.5581,
    y1: 27.8887,
    x2: 59.5581,
    y2: 33.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1194_22989",
    x1: 67.9999,
    y1: 48.2,
    x2: 67.9999,
    y2: 36.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1194_22989",
    x1: 16.3629,
    y1: 35.6761,
    x2: 26.1776,
    y2: 35.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1194_22989",
    x1: 31.1905,
    y1: 35.6761,
    x2: 41.0052,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1194_22989",
    x1: 46.0597,
    y1: 35.6761,
    x2: 55.8743,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1194_22989",
    x1: 60.8877,
    y1: 35.7181,
    x2: 70.7024,
    y2: 35.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1194_22989",
    x1: 75.7574,
    y1: 35.5931,
    x2: 85.5721,
    y2: 35.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1194_22989",
    x1: 90.5851,
    y1: 35.4681,
    x2: 100.4,
    y2: 35.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1194_22989",
    x1: 60,
    y1: 57,
    x2: 60,
    y2: 113.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E600EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9002FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_22989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyShare);
export default __webpack_public_path__ + "static/media/icon_empty_share.2b95ca54103cdefc4d0a832c7531aec7.svg";
export { ForwardRef as ReactComponent };